<template>
  <!-- The page's own shapes while the building loads, so nothing moves when it lands -->
  <View direction="column" gap="lg" aria-busy="true" data-testid="details-skeleton">
    <Text variant="h2">Building details</Text>

    <BuildingPhotos :images="[]" loading />

    <DetailsSectionHeader
      title="Shared by every unit"
      description="Changes here show on all units immediately — address, amenities, parking and access live on the building, not the unit."
    />
    <DetailsGrid>
      <PropertyDetailsCard v-for="card in sharedCards" :key="card.body" :class="{ 'full-size': card.wide }">
        <template #title><Skeleton width="8rem" height="1.25rem" /></template>
        <template #action><Skeleton width="2rem" height="2rem" /></template>
        <Skeleton :height="card.body" />
      </PropertyDetailsCard>
    </DetailsGrid>

    <DetailsSectionHeader
      title="Defaults for new units"
      description="Copied into a unit when it's created. After that each unit owns its copy — editing here changes nothing on existing units."
    />
    <DetailsGrid>
      <PropertyDetailsCard v-for="card in defaultCards" :key="card" tone="secondary">
        <template #title><Skeleton width="8rem" height="1.25rem" /></template>
        <template #action><Skeleton width="2rem" height="2rem" /></template>
        <Skeleton height="4rem" />
      </PropertyDetailsCard>
    </DetailsGrid>
  </View>
</template>

<script setup lang="ts">
import { Skeleton, Text, View } from '@tallo/design-system';
import { DetailsGrid, DetailsSectionHeader, PropertyDetailsCard } from '@tallo/property';

import BuildingPhotos from '../../components/building-photos.vue';

/** The shared cards in their places: building and location, amenities and parking, accessibility across */
const sharedCards = [
  { body: '9rem' },
  { body: '9.5rem' },
  { body: '5rem' },
  { body: '5.5rem' },
  { body: '3rem', wide: true },
];
const defaultCards = 4;
</script>
